const Tooltip = {
  baseStyle: props => ({
    color: props.colorMode === "dark" ? "whiteAlpha.900" : "gray.800",
    bg: props.colorMode === "dark" ? "gray.700" : "white",
    shadow: props.colorMode === "light" ? "light.md" : "dark.lg",
    rounded: "sm"
  })
};

export default Tooltip;